import React from 'react'
import { Grid, GridCell } from '@mobi/component-library/Common/Grid'
import dayjs from 'dayjs'
import {
  RaceListHeaderStyled,
  RaceListHeaderDetails,
  RaceListCenteredHeaderStyled,
} from './RaceListHeader.styles'
import { ContentHeaderStyled } from '@core/Areas/Racing/Components/RaceEvents/Components/RaceEventsHeader/RaceEventsHeader.styles'
import { ButtonWithIcon } from '@mobi/component-library/Common/Buttons'
import { Icon } from '@mobi/component-library/Common/Icon'
import { appHistory } from '@core/Utils/routing/history'
import { AppRoutes } from '@core/AppRoutes'
import { RaceCondtitionIcon } from '@core/Areas/RaceList/RaceList.styles'
import { IconTypes, unknownWeather, WeatherTypes } from './utils'
import { Link } from 'react-router'

export const RaceListHeader = ({
  title,
  code,
  weather,
  condition,
  eventDate,
}: {
  title: string
  code: string
  weather: string
  condition: string
  eventDate: string
}): JSX.Element => {
  return (
    <div>
      <ContentHeaderStyled>
        <Grid>
          <GridCell width='2rem' valign='middle'>
            <ButtonWithIcon
              onClick={() => appHistory.push(AppRoutes.Home)}
              icon={<Icon type='house' title='Home' />}
              color='light'
            />
          </GridCell>
          <GridCell valign='middle' align='center'>
            <h2>
              <Link
                to={`/tote?code=${(code || '').toLowerCase()}&date=${dayjs(eventDate).format(
                  'YYYY-MM-DD'
                )}`}
              >
                <Icon type={IconTypes[code]} /> {title}
              </Link>
            </h2>
          </GridCell>
          <GridCell width='2rem' valign='middle' />
        </Grid>
      </ContentHeaderStyled>

      <RaceListHeaderStyled data-tid-page-sub-title=''>
        <RaceListCenteredHeaderStyled>
          <Grid>
            <RaceListHeaderDetails>
              <GridCell valign='middle' align='center'>
                {dayjs(eventDate).format('ddd DD MMM YYYY')}
              </GridCell>
              <GridCell valign='middle' align='center'>
                <RaceCondtitionIcon size='1.75rem' type={WeatherTypes[weather] || unknownWeather} />
                {weather}
              </GridCell>
              <GridCell valign='middle' align='center'>
                <RaceCondtitionIcon type='trackConditions' size='1.75rem' />
                {condition}
              </GridCell>
            </RaceListHeaderDetails>
          </Grid>
        </RaceListCenteredHeaderStyled>
      </RaceListHeaderStyled>
    </div>
  )
}
